import DashboardView from '../../pages/DashboardView';

// Nome simples (PT): Página de Dashboard
export default function PaginaDashboard(props) {
  return <DashboardView {...props} />;
}






